<template>
  <div>
    <div class="flex">
      <div class="leftBox">
        <h1 style="margin-bottom: 20px">异常数据总览</h1>
        <div v-for="item in list1" class="flex">
          <p>{{ item.key }}</p><span>{{ item.value }}</span>
        </div>
        <h1 style="margin-bottom: 20px;margin-top: 20px">各型号月异常平均数汇总</h1>
        <div v-for="item in list2" class="flex">
          <p>{{ item.key }}</p><span>{{ item.value.toFixed(2) }}</span>
        </div>
      </div>
      <div>
        <el-radio-group v-model="path"  size="medium" @change="tabPath">
          <el-radio-button label="/recipeStatistics/abnormal/abnormal">异常类型</el-radio-button>
          <el-radio-button label="/recipeStatistics/abnormal/model">型号</el-radio-button>
        </el-radio-group>
        <div style="margin-top: 20px">
          <keep-alive>
            <router-view v-if='$route.meta.keepAlive'></router-view>
          </keep-alive>
          <router-view v-if='!$route.meta.keepAlive'></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "anomaly",
  data() {
    return {
      path: "/recipeStatistics/abnormal/abnormal",
      list1:[],
      list2:[]
    }
  },
  created() {
    this.init()
    this.path=this.$route.path
  },
  component: {
    //someComponent
  },
  methods: {
    //
    tabPath(){
      this.$router.push(this.path)
    },
    init(){
      this.axios
          .get("/Statistics/PFExceptionDealStatistic/ExceptionStatisticInfo").then((res) => {
            this.list1=res
      })
      this.axios
          .get("/Statistics/PFExceptionDealStatistic/GetExceptionByDeviceType").then((res) => {
            this.list2=res
      })
    }
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.flex {
  .leftBox{
    width: 300px;
    border-right: 1px solid #eee;
    margin-right: 15px;
    &>div{
      height: 40px;
      line-height: 40px;
      p{
        width: 160px;
        text-align: right;
        font-size: 16px;
      }
      span{
        margin-left: 10px;font-size: 16px;
      }
    }
  }
}
</style>